// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import {
  PlasmicPaziresh24Avatar,
  DefaultPaziresh24AvatarProps
} from "./plasmic/paziresh_24_design_system/PlasmicPaziresh24Avatar";
import { HTMLElementRefOf, PlasmicImg } from "@plasmicapp/react-web";
import { PIC_USER_IMAGE_FALLBACK_URL } from "@/common/utils/picUserImageUrl";

// Your component props start with props for variants and slots you defined
// in Plasmic, but you can add more here, like event handlers that you can
// attach to named nodes in your component.
//
// If you don't want to expose certain variants or slots as a prop, you can use
// Omit to hide them:
//
// interface Paziresh24AvatarProps extends Omit<DefaultPaziresh24AvatarProps, "hideProps1"|"hideProp2"> {
//   // etc.
// }
//
// You can also stop extending from DefaultPaziresh24AvatarProps altogether and have
// total control over the props for your component.
export interface Paziresh24AvatarProps extends DefaultPaziresh24AvatarProps {
  // DR-08 perf fix (docs/dev-requests/dr-08-listing-pagespeed.md §۱۱): expose the underlying
  // PlasmicImg override so callers can set e.g. `img={{ loading: 'eager', fetchPriority: 'high' }}`
  // for an LCP-candidate avatar (first result card) instead of always inheriting the hardcoded
  // `loading="lazy"` baked into the generated PlasmicPaziresh24Avatar. Previously this prop was
  // silently dropped (see git history) because `img={{ onError: handleImageError }}` below was
  // spread *after* `{...props}`, clobbering any `props.img` a caller passed in.
  //
  // Typed as a plain object (not the full generated `Flex<typeof PlasmicImg__>` union, which also
  // allows render-prop/`{wrap,props}` shapes) so it stays safely spreadable below — this wrapper
  // only ever needs to forward plain PlasmicImg/<img> attributes (loading, fetchPriority, ...).
  img?: Partial<React.ComponentProps<typeof PlasmicImg>>;
}

function Paziresh24Avatar_(
  props: Paziresh24AvatarProps,
  ref: HTMLElementRefOf<"div">
) {
  const [src, setSrc] = React.useState(props.src);
  const [usedFallback, setUsedFallback] = React.useState(false);

  React.useEffect(() => {
    setSrc(props.src);
    setUsedFallback(false);
  }, [props.src]);

  const handleImageError = () => {
    if (!usedFallback && src !== PIC_USER_IMAGE_FALLBACK_URL) {
      setUsedFallback(true);
      setSrc(PIC_USER_IMAGE_FALLBACK_URL);
      return;
    }
    setSrc(undefined);
  };

  return (
    <PlasmicPaziresh24Avatar
      root={{ ref }}
      {...props}
      src={src}
      img={{ onError: handleImageError, ...props.img }}
    />
  );
}

const Paziresh24Avatar = React.forwardRef(Paziresh24Avatar_);
export default Paziresh24Avatar;
